// extracted by mini-css-extract-plugin
export default {"flex":"Botons_flex__9zi4S","card":"Botons_card__jLyyA","gnp":"Botons_gnp__BFF96","hdi":"Botons_hdi__rSW2m"};